import React, { useEffect } from 'react';
import FollowUs from './FollowUs';
import ContentPageLayout from './ContentPageLayout';

const FollowUsPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Follow Us - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Follow DeliFeed on social media for the latest updates, special offers, and delicious food inspiration. Find us on Facebook and Instagram.');
        }
    }, []);

    return (
        <ContentPageLayout title="Follow Us" hideFollowButtons={true}>
            <FollowUs />
        </ContentPageLayout>
    );
};

export default FollowUsPage;
